import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { aboutConsiderations, images } from '../data/content';
export function About() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="about-title" data-id="element-19" data-mp="2ttburtpgi0j4">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[2fr_3fr] md:items-start" data-id="element-20" data-mp="2ys5aztw4o5mz">
        <div className="md:sticky md:top-8" data-id="element-21" data-mp="2ypsmexvv6x0y">
          <div className="overflow-hidden rounded-3xl border-4 border-gold bg-cream" data-id="element-22" data-mp="33q6v8i5aib01">
            <img src={images.doctor} alt="Dr. Nathan Brooks in his dental clinic" className="h-auto w-full object-cover" data-id="element-23" data-mp="38pjg4xclp7zz" />
          </div>
          <p className="mt-4 text-center font-serif text-xl font-bold text-navy" data-id="element-24" data-mp="3dhurqxgpei8d">Dr. Nathan Brooks</p>
          <p className="text-center text-sm text-ink-muted" data-id="element-25" data-mp="3hhv4mdo5mldb">Creator of Oral Rehabilitation Blueprint™</p>
        </div>

        <div data-id="element-26" data-mp="3mfwm4u5xmcmo">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-27" data-mp="3rgu6ndeezirc">About Dr. Nathan Brooks</p>
          <h2 id="about-title" className="mt-3 font-serif text-[30px] font-extrabold leading-[1.12] text-navy sm:text-4xl" data-id="element-28" data-mp="2lqz0k0756akw">
            Why I Created <span className="italic text-gold" data-id="element-29" data-mp="2grcnbqrbcuc3">Oral Rehabilitation Blueprint™</span>
          </h2>
          <div className="mt-6 space-y-4 text-[16px] leading-relaxed text-ink-muted" data-id="element-30" data-mp="2crc1vm5srivj">
            <p data-id="element-31" data-mp="27shj2k7txubf">For years, I’ve recognized a challenge many dental professionals face when organizing complex oral rehabilitation cases.</p>
            <p className="font-semibold text-navy" data-id="element-32" data-mp="34jt6y5qp8udi">The difficulty isn’t always a lack of knowledge.</p>
            <p data-id="element-33" data-mp="30i7xyvhad08l">
              Professionals may have studied restorative dentistry, prosthodontics, occlusion, function, and aesthetics — and still
              find it challenging to bring all the information together into one coherent treatment roadmap. When a complex case
              comes in, several things need to be considered:
            </p>
          </div>
          <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-34" data-mp="3jdel5auv7oco">
            {aboutConsiderations.map(c => <li key={c} className="flex gap-2 text-[15px] text-navy" data-id="element-35" data-mp="66dfvz4s94v0">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={3} data-id="element-36" data-mp="b3vhf4gh0hsz" />
                {c}
              </li>)}
          </ul>
          <blockquote className="mt-7 border-l-4 border-gold bg-cream px-5 py-4 font-serif text-xl font-bold italic leading-snug text-navy" data-id="element-37" data-mp="1evexb2rf4a1">
            “Before trying to organize a complex case in your head, give yourself a clear structure for organizing the information on paper.”
          </blockquote>
          <div className="mt-6 space-y-4 text-[16px] leading-relaxed text-ink-muted" data-id="element-38" data-mp="3akjz0bvbvxxc">
            <p data-id="element-39" data-mp="3eldnp7glhgra">
              My intention wasn’t to create another enormous textbook you’d read once and leave on a shelf. I wanted a practical
              collection of visual tools you could revisit whenever you need a clearer structure.
            </p>
            <p data-id="element-40" data-mp="1cthdq2a2seym">
              Oral Rehabilitation Blueprint™ is designed to support your existing clinical knowledge, not replace your professional
              training, patient-specific assessment, or clinical judgment.
            </p>
            <p className="font-serif text-lg font-bold italic text-navy" data-id="element-41" data-mp="371uphtys5gy4">— Dr. Nathan Brooks</p>
          </div>

          <div className="mt-8" data-id="element-42" data-mp="32aw5ajao7ypl">
            <CtaButton label="I Want Oral Rehabilitation Blueprint™" data-id="element-43" data-mp="329uumfxkhe8e" />
          </div>
        </div>
      </div>
    </section>;
}